/** @jsx jsx */
import { jsx } from 'theme-ui'
import Grid from '../helpers/grid'
import MoreWinnersCard from './moreWinnersCard'
import { WINNERS_CONFIG } from './moreInfoConfig'

const IndustrySection = () => (
  <div sx={{ textAlign: 'center' }}>
    <h3
      sx={{
        fontSize: '36px',
        marginBottom: [32, 48],
        marginTop: ['48px', '64px']
      }}
    >
      Industry
    </h3>
    <Grid
      gridTemplateColumns={[
        'repeat(2, minmax(0, 1fr))',
        'repeat(2, minmax(0, 320px))',
        'repeat(2, 320px)'
      ]}
      gap={['8px', '32px']}
    >
      {[
        WINNERS_CONFIG.bestTelecomsInovation,
        WINNERS_CONFIG.bestRefurbished
      ].map((award) => (
        <MoreWinnersCard
          key={award.awardTitle}
          awardLabel={award.awardLabel}
          awardTitle={award.awardTitle}
          awardSubtitle={award.awardSubtitle}
          providerName={award.providerName}
          winnersLogo={award.moreWinnersLogoCard}
          modalContent={award}
          ctaHref={award.providerLink}
          ctaText={award.ctaTitle}
          ctaTextMobile={award.ctaTitleMobile}
        />
      ))}
    </Grid>
  </div>
)

export default IndustrySection
